// extracted by mini-css-extract-plugin
module.exports = {"root":"PersonAvatar_root___dgyz","inbound":"PersonAvatar_inbound__B1GO0"};